import { call, CallEffect, PutEffect } from 'redux-saga/effects'
import { orderBy } from 'lodash'
import { AxiosResponse } from 'axios'
import { Action } from 'redux-saga';
import { automaticApi } from '@/settings/api';

export interface Fetch {
    type: string;
    callback: (success: boolean, errorMessage?: string | unknown) => void;
}

export interface RequestBrandsAction {
    type: string;
    payload: Fetch;
}

const uri = '/dominios/v1/veiculo/marcas'

export default function* requestBrands({
    payload,
}: RequestBrandsAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const body = {
            tipoVeiculo: payload.type ?? 1,
        }

        const res = yield call(automaticApi.post, uri, body)

        if (res?.data?.totalRegistros > 0) {
            const brands = orderBy(res?.data?.listaMarcasVeiculo, ['descricao', 'ASC'])
            const transformedBrands = brands.map(((item: {
                descricao: string;
                identificadorMarcaVeiculo: string;
            }) => ({
                text: item.descricao,
                value: item.identificadorMarcaVeiculo,
                ...item,
            })));
            yield call(payload.callback, true, transformedBrands);
        } else {
            yield call(payload.callback, false);
        }
    } catch (error) {
        yield call(payload.callback, false);
    }
}
